<!-- eslint-disable vue/max-len -->
<template>
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.78571 11.6652H8.87946C10.4156 11.6652 11.6652 10.4156 11.6652 8.87946V2.78571C11.6652 1.24958 10.4156 0 8.87946 0H2.78571C1.24958 0 0 1.24958 0 2.78571V8.87946C0 10.4156 1.24958 11.6652 2.78571 11.6652Z"
      fill="currentColor"
    />
    <path
      d="M23.2144 0H17.1207C15.5845 0 14.335 1.24958 14.335 2.78571V8.87946C14.335 10.4156 15.5845 11.6652 17.1207 11.6652H23.2144C24.7506 11.6652 26.0001 10.4156 26.0001 8.87946V2.78571C26.0001 1.24958 24.7506 0 23.2144 0Z"
      fill="currentColor"
    />
    <path
      d="M2.78571 26.0001H8.87946C10.4156 26.0001 11.6652 24.7505 11.6652 23.2144V17.1206C11.6652 15.5845 10.4156 14.3349 8.87946 14.3349H2.78571C1.24958 14.3349 0 15.5845 0 17.1206V23.2144C0 24.7505 1.24958 26.0001 2.78571 26.0001Z"
      fill="currentColor"
    />
    <path
      d="M25.0716 24.1429H15.2635C14.7503 24.1429 14.335 24.5587 14.335 25.0715C14.335 25.5843 14.7503 26.0001 15.2635 26.0001H25.0716C25.5848 26.0001 26.0001 25.5843 26.0001 25.0715C26.0001 24.5587 25.5848 24.1429 25.0716 24.1429Z"
      fill="currentColor"
    />
    <path
      d="M25.0716 14.3349H15.2635C14.7503 14.3349 14.335 14.7507 14.335 15.2635C14.335 15.7763 14.7503 16.192 15.2635 16.192H25.0716C25.5848 16.192 26.0001 15.7763 26.0001 15.2635C26.0001 14.7507 25.5848 14.3349 25.0716 14.3349Z"
      fill="currentColor"
    />
    <path
      d="M25.0716 19.2388H15.2635C14.7503 19.2388 14.335 19.6546 14.335 20.1674C14.335 20.6802 14.7503 21.096 15.2635 21.096H25.0716C25.5848 21.096 26.0001 20.6802 26.0001 20.1674C26.0001 19.6546 25.5848 19.2388 25.0716 19.2388Z"
      fill="currentColor"
    />
  </svg>
</template>
